<script setup lang="ts">
import LeCheckmark from "@dsk/icons/LeCheckmark.vue";

interface Props {
  modelValue?: boolean;
  disabled?: boolean;
}

const props = withDefaults(defineProps<Props>(), {
  modelValue: false,
  disabled: false
});

const emit = defineEmits<{
  (event: "update:modelValue", value: boolean): void;
}>();

const CLASS_NAME_CHECKBOX = "le-checkbox";
const baseClass = CLASS_NAME_CHECKBOX;
</script>

<template>
  <span :class="[baseClass]">
    <input
      type="checkbox"
      :class="[`${baseClass}__input`]"
      :checked="props.modelValue"
      :disabled="props.disabled"
      @change="emit('update:modelValue', ($event.target as HTMLInputElement).checked)"
    />
    <LeCheckmark :class="`${baseClass}__checkmark`"></LeCheckmark>
  </span>
</template>

<style scoped lang="less">
@import "@dsk/styles/all";

.le-checkbox {
  display: inline-flex;
  position: relative;
  cursor: pointer;

  &__input {
    flex-shrink: 0;
    width: 20px;
    height: 20px;
    margin: 0;
    border: solid 2px @colors[@primary][500];
    border-radius: 2px;
    outline: none;
    background-color: @colors[@neutrals][100];
    cursor: pointer;
    appearance: none;

    &:disabled {
      opacity: 0.3;
    }

    &:focus {
      box-shadow: 0px 0px 0px 4px rgba(27, 190, 163, 0.3);
    }

    &:checked {
      background: @colors[@primary][500];
    }
  }

  &__checkmark {
    display: none;
    position: absolute;
    top: 2px;
    left: 2px;
    color: @colors[@neutrals][100];
  }

  &__input:checked + .le-checkbox__checkmark {
    display: block;
    pointer-events: none;
  }
}
</style>
